import styled from 'styled-components';

export const Icon = styled.div`
  position: fixed;
  bottom: 30px;
  right: 60px;
  display: none;
  z-index: 2;

  &:hover {
    cursor: pointer;
  }

  svg {
    position: absolute;
    left: 50%;
    bottom: -20px;
    opacity: 0.2;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }
 `;
